import { render } from "./ProposerItem.vue?vue&type=template&id=365ebd39&scoped=true"
import script from "./ProposerItem.vue?vue&type=script&lang=js"
export * from "./ProposerItem.vue?vue&type=script&lang=js"

import "./ProposerItem.vue?vue&type=style&index=0&id=365ebd39&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365ebd39"]])

export default __exports__